import React from 'react'
import { FormattedMessage } from '@dragonraider5/react-intl'
import MainBanner from '../../../components/MainBanner'
import H1 from '../../../components/H1'
import messages from './messages'

function AppMainBanner() {
  return (
    <MainBanner>
      <H1>
        <FormattedMessage {...messages.mainBannerTitle} />
      </H1>
    </MainBanner>
  )
}

export default AppMainBanner
